import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_d9c679c0: FaireBrandEntity = {
  token: "b_d9c679c0",
  type: "brand",
  name: "Pigeon Toe Ceramics & Home Textiles",
  avatarUrl:
    "https://cdn.faire.com/fastly/b41fc8230437622c0f42f72c71deb3b953dbf051f3bf05cdc43177eb0db30c3d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/29c05519cc312f5f68e1559abc300540522bc62a667c312af656a2473e4e0ae9.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b41fc8230437622c0f42f72c71deb3b953dbf051f3bf05cdc43177eb0db30c3d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/29c05519cc312f5f68e1559abc300540522bc62a667c312af656a2473e4e0ae9.jpeg",
  location: "Portland, OR, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 12,
  isInsider: true,
  description:
    "Pigeon Toe is a female-owned brand with a playful and interdisciplinary approach to craft. We've been designing and manufacturing modern ceramics and home textiles from our studio in Portland, Oregon since 2009. ",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:19.494Z",
    importedBy: "entity-db-cli",
  },
};
